import SkuPicker from './SkuPicker.vue'

export default SkuPicker